// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"282":"views-app","768":"App"}[chunkId] || chunkId) + "." + {"19":"bc9671dd","282":"e73b8773","711":"0ac9c68d","768":"93bf75de"}[chunkId] + ".chunk.css";
};